import React from 'react';
import MaterialSnackbar from '@mui/material/Snackbar';
import MaterialIconButton from '@mui/material/IconButton';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import {
  FDBodyText, FDEmphasisSurface, FDIcon, FDStack,
} from '@facet-wealth/design';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = buildUseStyles('EmphasizedSnackbar', (() => ({
  title: {
    fontWeight: 700,
  },
})));


// This is an experimental version of a snackbar which conveys more of an alert/notification rather than a specific
// status which is what the FDSnackbar use case is focused around today. Once we have a clearer idea of how we'd like to
// use this we should bring it into FD.
export const EmphasizedSnackbar = ({
  open,
  onClose,
  autoHideDuration,
  position,
  title,
  description,
  ...restProps
}) => {
  const classes = useStyles();
  const [vertical, horizontal] = position.split(' ');
  return (
    <MaterialSnackbar
      {...restProps}
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{ vertical, horizontal }}
    >
      <div> {/* The first child of a Snackbar must be an element that can hold a ref */}
        <FDEmphasisSurface padding={2}>
          <FDStack spacing={2} alignItems={'flex-start'} justifyContent={'space-between'}>
            <FDStack direction={'column'}>
              <FDBodyText value={<span className={classes.title}>{title}</span>} />
              <FDBodyText value={description} />
            </FDStack>
            <MaterialIconButton
              onClick={onClose}
              aria-label="close"
              sx={{
                paddingY: 0,
                paddingX: 0,
                width: '20px',
                height: '20px',
              }}
              disableRipple
            >
              <FDIcon icon="close" size="sm" />
            </MaterialIconButton>
          </FDStack>
        </FDEmphasisSurface>
      </div>
    </MaterialSnackbar>
  );
};

EmphasizedSnackbar.defaultProps = {
  onClose: noop,
  autoHideDuration: 5000,
  position: 'top center',
};

EmphasizedSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  autoHideDuration: PropTypes.number,
  position: PropTypes.string,
};
